import Vue from "vue";
import App from "@/App.vue";
import "@/plugins/sentry";
import router from "@/router";
import store from "@/store";
import i18n from "@/plugins/i18n";
import "@/plugins/vuelidate";
import "@/assets/css/tailwind.css";
import "@/assets/sass/app.scss";
import "@/globalComponents.ts";
import "@/plugins/hotjar";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
